/* tslint:disable */
import {
  TemplateHeader
} from '../index';

declare var Object: any;
export interface WMAssignmentPDVReasonInterface {
  "sfdcId"?: string;
  "Name"?: string;
  "CurrencyIsoCode"?: string;
  "CreatedById"?: string;
  "LastModifiedById"?: string;
  "CreatedBy__c"?: string;
  "LastModifiedBy__c"?: string;
  "Additional_Notes__c"?: string;
  "Approved_Negotiation_Date_Time__c"?: Date;
  "Automated_Rule__c"?: boolean;
  "Created_By_Contact__c"?: string;
  "CreatedDate_Bucket__c"?: string;
  "Expenses_Approved__c"?: number;
  "Hours_Approved__c"?: number;
  "Job__c"?: string;
  "Job_Type__c"?: string;
  "Last_Modified_By_Contact__c"?: string;
  "PET_Last_Modified_User__c"?: string;
  "PET_Last_Modified_User_Id__c"?: string;
  "PgMO_Tasks__c"?: string;
  "Problem_Code__c"?: string;
  "Problem_Task_Reason_Code__c"?: string;
  "Rate_Approved__c"?: number;
  "Reason_Category__c"?: string;
  "Reason_Type__c"?: string;
  "Reason_Values__c"?: string;
  "Serviceo_Problem_Reason_Codes__c"?: string;
  "Vendor__c"?: string;
  "Vendor_Rating_Related__c"?: boolean;
  "WM_Assignment__c"?: string;
  "WM_Offer_Detail__c"?: string;
  "Worker_Approved_Negotitator__c"?: string;
  "Worker_Rating_Related__c"?: boolean;
  "Worker_Type__c"?: string;
  "id"?: number;
  "PgMO_Template_Header__c"?: string;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  templateHeader?: TemplateHeader;
}

export class WMAssignmentPDVReason implements WMAssignmentPDVReasonInterface {
  "sfdcId": string;
  "Name": string;
  "CurrencyIsoCode": string;
  "CreatedById": string;
  "LastModifiedById": string;
  "CreatedBy__c": string;
  "LastModifiedBy__c": string;
  "Additional_Notes__c": string;
  "Approved_Negotiation_Date_Time__c": Date;
  "Automated_Rule__c": boolean;
  "Created_By_Contact__c": string;
  "CreatedDate_Bucket__c": string;
  "Expenses_Approved__c": number;
  "Hours_Approved__c": number;
  "Job__c": string;
  "Job_Type__c": string;
  "Last_Modified_By_Contact__c": string;
  "PET_Last_Modified_User__c": string;
  "PET_Last_Modified_User_Id__c": string;
  "PgMO_Tasks__c": string;
  "Problem_Code__c": string;
  "Problem_Task_Reason_Code__c": string;
  "Rate_Approved__c": number;
  "Reason_Category__c": string;
  "Reason_Type__c": string;
  "Reason_Values__c": string;
  "Serviceo_Problem_Reason_Codes__c": string;
  "Vendor__c": string;
  "Vendor_Rating_Related__c": boolean;
  "WM_Assignment__c": string;
  "WM_Offer_Detail__c": string;
  "Worker_Approved_Negotitator__c": string;
  "Worker_Rating_Related__c": boolean;
  "Worker_Type__c": string;
  "id": number;
  "PgMO_Template_Header__c": string;
  "createdAt": Date;
  "updatedAt": Date;
  templateHeader: TemplateHeader;
  constructor(data?: WMAssignmentPDVReasonInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `WMAssignmentPDVReason`.
   */
  public static getModelName() {
    return "WMAssignmentPDVReason";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of WMAssignmentPDVReason for dynamic purposes.
  **/
  public static factory(data: WMAssignmentPDVReasonInterface): WMAssignmentPDVReason{
    return new WMAssignmentPDVReason(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'WMAssignmentPDVReason',
      plural: 'WMAssignmentPDVReasons',
      path: 'WMAssignmentPDVReasons',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "CreatedBy__c": {
          name: 'CreatedBy__c',
          type: 'string'
        },
        "LastModifiedBy__c": {
          name: 'LastModifiedBy__c',
          type: 'string'
        },
        "Additional_Notes__c": {
          name: 'Additional_Notes__c',
          type: 'string'
        },
        "Approved_Negotiation_Date_Time__c": {
          name: 'Approved_Negotiation_Date_Time__c',
          type: 'Date'
        },
        "Automated_Rule__c": {
          name: 'Automated_Rule__c',
          type: 'boolean'
        },
        "Created_By_Contact__c": {
          name: 'Created_By_Contact__c',
          type: 'string'
        },
        "CreatedDate_Bucket__c": {
          name: 'CreatedDate_Bucket__c',
          type: 'string'
        },
        "Expenses_Approved__c": {
          name: 'Expenses_Approved__c',
          type: 'number'
        },
        "Hours_Approved__c": {
          name: 'Hours_Approved__c',
          type: 'number'
        },
        "Job__c": {
          name: 'Job__c',
          type: 'string'
        },
        "Job_Type__c": {
          name: 'Job_Type__c',
          type: 'string'
        },
        "Last_Modified_By_Contact__c": {
          name: 'Last_Modified_By_Contact__c',
          type: 'string'
        },
        "PET_Last_Modified_User__c": {
          name: 'PET_Last_Modified_User__c',
          type: 'string'
        },
        "PET_Last_Modified_User_Id__c": {
          name: 'PET_Last_Modified_User_Id__c',
          type: 'string'
        },
        "PgMO_Tasks__c": {
          name: 'PgMO_Tasks__c',
          type: 'string'
        },
        "Problem_Code__c": {
          name: 'Problem_Code__c',
          type: 'string'
        },
        "Problem_Task_Reason_Code__c": {
          name: 'Problem_Task_Reason_Code__c',
          type: 'string'
        },
        "Rate_Approved__c": {
          name: 'Rate_Approved__c',
          type: 'number'
        },
        "Reason_Category__c": {
          name: 'Reason_Category__c',
          type: 'string'
        },
        "Reason_Type__c": {
          name: 'Reason_Type__c',
          type: 'string'
        },
        "Reason_Values__c": {
          name: 'Reason_Values__c',
          type: 'string'
        },
        "Serviceo_Problem_Reason_Codes__c": {
          name: 'Serviceo_Problem_Reason_Codes__c',
          type: 'string'
        },
        "Vendor__c": {
          name: 'Vendor__c',
          type: 'string'
        },
        "Vendor_Rating_Related__c": {
          name: 'Vendor_Rating_Related__c',
          type: 'boolean'
        },
        "WM_Assignment__c": {
          name: 'WM_Assignment__c',
          type: 'string'
        },
        "WM_Offer_Detail__c": {
          name: 'WM_Offer_Detail__c',
          type: 'string'
        },
        "Worker_Approved_Negotitator__c": {
          name: 'Worker_Approved_Negotitator__c',
          type: 'string'
        },
        "Worker_Rating_Related__c": {
          name: 'Worker_Rating_Related__c',
          type: 'boolean'
        },
        "Worker_Type__c": {
          name: 'Worker_Type__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "PgMO_Template_Header__c": {
          name: 'PgMO_Template_Header__c',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        templateHeader: {
          name: 'templateHeader',
          type: 'TemplateHeader',
          model: 'TemplateHeader',
          relationType: 'belongsTo',
                  keyFrom: 'PgMO_Template_Header__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
